export default __webpack_public_path__ + "static/wire4-6ca74866cf54e0e23a181b37a0e54fd6.png";